import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMaterialUIController } from "context";
import getNotificationsByCustomers from "api/notification/getNotificationsByCustomers";
import Pagination from "layouts/dashboards/stealers/pagination";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Divider from "@mui/material/Divider";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import moment from "moment";

// @mui material Icons
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LinkIcon from "@mui/icons-material/Link";
import ServerError from "utilities/ServerError";
import { Link } from "react-router-dom";

function AlertsPage() {
  // eslint-disable-next-line
  const [controller, dispatch] = useMaterialUIController();
  const { user, customers } = controller;
  const [notifications, setNotifications] = useState([]);
  // eslint-disable-next-line
  const [pages, setPages] = useState(0);
  // eslint-disable-next-line
  const [page, setPage] = useState(1);
  // eslint-disable-next-line
  const [limit, setLimit] = useState(50);
  const [serverError, setServerError] = useState(false);
  const { t } = useTranslation();

  function refreshNotifications() {
    if (user && customers && customers.length > 0) {
      getNotificationsByCustomers(page, limit)
        .then((res) => {
          if (res.totalPages) {
            setPages(res.totalPages);
          }
          if (res && res.results && res.results.length > 0) {
            setNotifications(res.results);
            if (
              window?.location?.href &&
              window.location.href.includes("#") &&
              window.location.href.split("#") &&
              window.location.href.split("#").length > 1
            ) {
              const notId = window.location.href.split("#")[1];
              if (document.getElementById(`notification-${notId}`)) {
                document.getElementById(`notification-${notId}`).scrollIntoView({
                  behavior: "smooth",
                });
              }
            }
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log("error while getting notifications", err);
          setServerError(true);
        });
    }
  }

  useEffect(() => {
    // console.log("customers", customers);
    refreshNotifications();
  }, [user, customers, page, limit]);

  function checkNumber(type) {
    if (!type) {
      return "";
    }
    const firstChar = type.charAt(0);
    if (Number(firstChar)) {
      const arr = type.split("-");
      return arr[1];
    }
    return type;
  }

  function getTitle(type) {
    return t(`analytics.title_${checkNumber(type)}`);
  }

  function getText(type) {
    if (!type) {
      return "";
    }
    if (type.includes("-")) {
      return `${type.split("-")[0]} ${t(`analytics.text_${type.split("-")[1]}`)}`;
    }
    return t(`analytics.text_${checkNumber(type)}`);
  }

  function getColor(type) {
    if (!type) {
      return "#0BC0A0";
    }
    const str = type.replace(/[0-9]/g, "");
    if (str === "-credentials_found" || str === "ransomware") {
      return "#CF1A1A";
    }
    return "#0BC0A0";
  }

  const notificationMap = {
    stealers: "/identity",
    combolists: "/identity",
    breaches: "/databreaches",
    itdrs: "/itdr",
    phishingCanaryWhitelist: "/phishing-canary-whitelist",
    cyberincidents: "/darkweb",
    phishings: "/phishing",
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <h2>{t("alerts.title")}</h2>
      {!serverError ? (
        <MDBox className="boxes-border-radius" padding={2.3} sx={{ background: "white" }}>
          {notifications.length > 0 ? (
            notifications.map((item) => (
              <div
                id={`notification-${item._id.toString()}`}
                key={`notification-${item._id.toString()}`}
              >
                <MDBox mt={2}>
                  <MDTypography
                    mb={1}
                    fontSize="large"
                    fontWeight="bold"
                    sx={{ color: getColor(item.type) }}
                  >
                    {getTitle(item.type)}
                  </MDTypography>
                  <MDTypography mb={1} fontSize="medium">
                    {getText(item.type)}
                  </MDTypography>
                  {item.type && item.type.includes("credentials_found") ? (
                    <MDTypography mb={1} fontSize="medium" className="notification-links-container">
                      {Object.keys(notificationMap).map((key) => {
                        const value = item[key];
                        if (!value || !Array.isArray(value) || value.length === 0) return null;

                        return (
                          <Link
                            key={`${item._id.toString()}-${key}`}
                            to={notificationMap[key]}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <div
                              className="notification-link-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                marginBottom: "6px",
                              }}
                            >
                              <LinkIcon fontSize="small" style={{ marginRight: "6px" }} />
                              <span>
                                {t("alerts.elements_involved")} — <strong>{key}</strong> (
                                {value.length})
                              </span>
                            </div>
                          </Link>
                        );
                      })}
                    </MDTypography>
                  ) : null}
                  <MDBox display="flex" alignItems="center">
                    <CalendarTodayIcon />
                    <MDTypography
                      variant="button"
                      color="dark"
                      fontSize="small"
                      fontWeight="light"
                      ml={1}
                    >
                      {moment(item.date).format("DD/MM/YYYY - HH:mm UTCZ")}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <Divider sx={{ border: "1px solid lightgrey", marginTop: "17px" }} />
              </div>
            ))
          ) : (
            <h5>{t("analytics.no_alerts")}</h5>
          )}
        </MDBox>
      ) : (
        <ServerError />
      )}
      {pages && pages > 1 ? <Pagination setPage={setPage} pages={pages} active={page} /> : null}
    </DashboardLayout>
  );
}

export default AlertsPage;
